var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarningTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6031 15.8032C13.6031 16.4353 13.1092 16.9478 12.5 16.9478C11.8908 16.9478 11.3969 16.4353 11.3969 15.8032C11.3969 15.1711 11.8908 14.6587 12.5 14.6587C13.1092 14.6587 13.6031 15.1711 13.6031 15.8032Z",
    fill: "currentColor",
    fillOpacity: 1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1961 9.31741C11.7659 9.31741 11.4275 9.69894 11.4633 10.1438L11.7365 13.5458C11.7524 13.7435 11.9117 13.8956 12.1029 13.8956H12.8971C13.0883 13.8956 13.2476 13.7435 13.2635 13.5458L13.5368 10.1438C13.5725 9.69894 13.2341 9.31741 12.8039 9.31741H12.1961Z",
    fill: "currentColor",
    fillOpacity: 1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5844 5.15339C11.4314 3.61554 13.5686 3.61554 14.4156 5.15339L20.7061 16.5752C21.5465 18.1012 20.4845 20 18.7905 20H6.20951C4.5155 20 3.45349 18.1012 4.29395 16.5752L10.5844 5.15339ZM13.1385 5.91054C12.8562 5.39792 12.1438 5.39792 11.8615 5.91054L5.57099 17.3323C5.29083 17.841 5.64484 18.4739 6.20951 18.4739H18.7905C19.3552 18.4739 19.7092 17.841 19.429 17.3323L13.1385 5.91054Z",
    fill: "currentColor",
    fillOpacity: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningTriangle);
export default __webpack_public_path__ + "static/media/warning-triangle.dd71a088bdffc5747fe6b399a0c4fb6e.svg";
export { ForwardRef as ReactComponent };